import * as React from "react";
import { connect } from "react-redux";
import { defaultYear } from "src/constants/ApiSettings";
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import SectionHeading from "src/components/general/SectionHeading";
import RelativeRisk from "./RelativeRisk";

// const sectionProps = [
//   {
//     ordinal: 1,
//     risk: "Higher" as "Higher" // This is because I used literals ( 'as' defines the type, otherwise it assumes string )
//   },
//   {
//     ordinal: 1,
//     risk: "Higher" as "Higher"
//   },
//   {
//     ordinal: 1,
//     risk: "Lower" as "Lower"
//   },
//   {
//     ordinal: 1,
//     risk: "Moderate" as "Moderate"
//   }
// ];

class CouncilSustainability extends React.PureComponent<
  IConnectedModuleProps,
  IConnectedModuleState
> {
  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = defaultYear;

    this.state = { selectedYear };
  }

  public render() {
    return (
      <section id="sustainability-footer" className="mt-10">
        <div className="container text-center justify-center">
          <SectionHeading
            heading="Is my council financially sustainable?"
            alignment="center"
            learnMore={ "sustainabilityMeasures" }
            councilSays={ "sustainabilityMeasuresCouncilSays" }
            inverse={ false }
          />
          <p className="max-w-lg mx-auto">A local council is financially stable if the local council is able to maintain its financial capital and infrastructure capital over the long term.</p>
        </div>

        <div className="mt-12">
          <div className="container">
            <div className="max-w-sm mx-auto">
              <SectionHeading
                heading="Current financial year sustainability measures and Relative Risk Assessment"
                subheading={ true }
                alignment="center"
                learnMore={ "qaoRelativeRiskAssessmentLevel" }
                councilSays={ "qaoRelativeRiskAssessmentLevelCouncilSays" }
                inverse={ false }
              />
            </div>
          </div>
          <div className="py-6 overflow-auto px-5 lg:px-0">
            <RelativeRisk 
              councils={this.props.councils} 
              year={this.state.selectedYear} 
            />
          </div>
          <div className="container">
            <p className="disclaimer-text max-w-lg mx-auto text-center">The QAO assesses council's financial sustainability each year. An overall 'relative risk assessment' is used to highlight potential risk to the council's financial sustainability over the long term when performance is assessed against established targets.</p>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilSustainability);



// WEBPACK FOOTER //
// ./src/components/report/councilSustainability/index.tsx